/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request to start transcription for a video media file.
 * @export
 * @interface StartTranscriptionRequest
 */
export interface StartTranscriptionRequest {
    /**
     * Media file UUID for which to start transcription
     * @type {string}
     * @memberof StartTranscriptionRequest
     */
    mediaId: string;
}

/**
 * Check if a given object implements the StartTranscriptionRequest interface.
 */
export function instanceOfStartTranscriptionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mediaId" in value;

    return isInstance;
}

export function StartTranscriptionRequestFromJSON(json: any): StartTranscriptionRequest {
    return StartTranscriptionRequestFromJSONTyped(json, false);
}

export function StartTranscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartTranscriptionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaId': json['media_id'],
    };
}

export function StartTranscriptionRequestToJSON(value?: StartTranscriptionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_id': value.mediaId,
    };
}

